export class RolUsuario {
    idRol: number;
    idUsuario: number;
    idSucursal: number;
    checked: boolean;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/rolUsuario.ts